import moment from 'moment-timezone';
import { findTimeZone } from 'timezone-support/index-1900-2050';

export const getDefaultTimeZone = (time_zone = '') => {
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let timeZone;
  if (time_zone) {
    // If a specific timezone is provided, preserve it
    timeZone = time_zone;
  } else {
    // Only use findTimeZone for browser timezone to get canonical name
    timeZone = findTimeZone(browserTimeZone)?.name || browserTimeZone;
  }

  const offset = moment.tz(timeZone).format('Z'); // Get the GMT offset
  const formattedOffset = offset.startsWith('+')
    ? `(GMT${offset})`
    : `(GMT${offset})`;

  return { label: `${formattedOffset} ${timeZone}`, key: timeZone };
};

export const convertDateFormatForDatePicker = (dateStr) => {
  if (!dateStr) return '';
  const [day, month, year] = dateStr.includes('/')
    ? dateStr.split('/')
    : dateStr.includes('-')
      ? dateStr.split('-')
      : dateStr.split(' ');
  return `${month}/${day}/${year}`;
};
